import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./screen/HomePage";
import Achievers from "./screen/Achievers";
import BlogDetail from "screen/BlogDetail";
import Layout from "./Layout/Layout";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from "react-helmet-async";

import "flag-icons/css/flag-icons.min.css";
import NotFound from "screen/NotFound";
import ScrollToTop from "Util/ScrollToTop";
import Blogs from "screen/Blogs";
import DownloadResourcesPage from "screen/Resoures/DownloadResourcesPage";
import ReportPage from "screen/Report/ReportPage";

function App() {
  return (
    // <>
    //   <Toaster position="bottom-left" />
    //   <Router>
    //     <ScrollToTop />;{/* ✅ CORRECT POSITION */}
    //     <Routes>
    //       <Route
    //         path="/"
    //         element={
    //           <Layout>
    //             <HomePage />
    //           </Layout>
    //         }
    //       />

    //       <Route
    //         path="/achievers"
    //         element={
    //           <Layout>
    //             <Achievers />
    //           </Layout>
    //         }
    //       />

    //       <Route
    //         path="/blogs"
    //         element={
    //           <Layout>
    //             <Blogs />
    //           </Layout>
    //         }
    //       />
    //       <Route
    //         path="/blog/:id"
    //         element={
    //           <Layout>
    //             <BlogDetail />
    //           </Layout>
    //         }
    //       />

    //       <Route
    //         path="*"
    //         element={
    //           <Layout>
    //             <NotFound />
    //           </Layout>
    //         }
    //       />
    //     </Routes>
    //   </Router>
    // </>

    <HelmetProvider>
      <Router>
        <ScrollToTop />

        <Toaster position="bottom-left" />

        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/achievers" element={<Achievers />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:id" element={<BlogDetail />} />

            <Route path="/free-download" element={<DownloadResourcesPage />} />
            <Route path="/report" element={<ReportPage />} />

            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
